<template>
	<div class="wrapper">
		<v-alert v-if="errorMessage" type="error" >{{ errorMessage }}</v-alert>
		<v-progress-circular v-else-if="loading" indeterminate />
		<flip-book :digital-book="digitalBook" v-else-if="digitalBook" />
	</div>
</template>

<script>
import { client } from '../../PlicCanvas/vue/utils/axios';
import FlipBook from './FlipBook';

export default {
	data: () => {
		return {
			loading: true,
			errorMessage: null,
			digitalBook: null
		};
	},
	mounted() {
		client.get('/api/v1/digital-book?bookId=' + this.$route.params.id).then((response) => {
			this.loading = false;
			this.digitalBook = response.data.digitalBook;

			this.$emit('updateRouteTitle', response.data.digitalBook.orgName + ' Book');
			this.$emit('updateProps', {
				fullScreen: true
			});
		}).catch((e) => {
			this.loading = false;
			this.errorMessage = 'Failed to load digital book info';
			console.error('Failed to load digital book info', e);
		});
	},
	components: {
		FlipBook
	}
};
</script>

<style scoped>
	.wrapper {
		width: 100%;
		height: 100%;
		z-index: 100;
	}
</style>